<template>
  <div>
    <div :class="['input', inputState]" @click="start">
      <div
        v-if="picture.length"
        :class="['input__picture', inputState]">
        <svg :class="inputState">
          <use :xlink:href="`#${picture}`" />
        </svg>
      </div>
      <div :class="['input__content', inputState]">
        <div :class="['input__content-prompt', inputState]">
          {{ title }}
        </div>
        <input
          ref="input"
          v-model="inputContent"
          v-mask="mask"
          :class="['input__content-input', inputState]"
          @blur="inputChanged"
        />
      </div>
    </div>
    <transition>
      <div v-if="showError" class="input__error">
        <div class="input__error-image">
          <img src="@/assets/img/new-error.svg" alt="phone">
        </div>
        <p class="input__error-text">{{ errorText }}</p>
      </div>
    </transition>
    <input-svg-sprite />
  </div>
</template>

<script>
import { DOUBLE_INPUT_CLASSES, DOUBLE_INPUT_STATUSES } from './const'
import InputSvgSprite from './InputSvgSprite'

export default {
  name: 'DoubleInput',
  components: { InputSvgSprite },
  props: {
    title: {
      type: String,
      default: '',
    },
    picture: {
      type: String,
      default: '',
    },
    mask: {
      type: String,
      default: '',
    },
    errorText: {
      type: String,
      default: '',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputContent: '',
      inputStatus: DOUBLE_INPUT_STATUSES.init,
    }
  },
  computed: {
    inputState() {
      if (this.inputStatus === DOUBLE_INPUT_STATUSES.validate) {
        return (this.hasError)
          ? DOUBLE_INPUT_CLASSES[DOUBLE_INPUT_STATUSES.error]
          : DOUBLE_INPUT_CLASSES[DOUBLE_INPUT_STATUSES.success]
      }

      return DOUBLE_INPUT_CLASSES[this.inputStatus]
    },
    showError() {
      return this.hasError && this.inputStatus !== DOUBLE_INPUT_STATUSES.edit
    },
  },
  methods: {
    start() {
      this.inputStatus = DOUBLE_INPUT_STATUSES.edit
      this.$refs.input.focus()
    },
    inputChanged() {
      this.inputStatus = DOUBLE_INPUT_STATUSES.validate
      this.$emit('input-changed', this.inputContent)
    },
  },
}
</script>

<style lang="sass" scoped>
.input
  display: flex
  width: 100%
  height: 5.6rem
  margin-bottom: 0.2rem
  border-radius: 0.8rem
  background: #F8F8F8
  cursor: pointer

  &.active
    border: 1px solid #FF7F37
  &.error
    border: 1px solid #FF3030
  &.success
    border: 1px solid #28B411

  &__picture
    display: flex
    justify-content: center
    align-items: center
    width: 5.6rem
    background: #EDEDED
    border-radius: 8px 0 0 .8rem
    &.error
      background: #FFC0C0
    svg
      width: 1.6rem
      height: 1.6rem
      fill: #7C7B7B
      &.success
        fill: #28B411

  &__content
    flex: 1
    display: flex
    flex-direction: column
    justify-content: center
    padding: 0.6rem 1.2rem
    border-radius: 0.8rem
    &.error
      background: #FFF2F2

    &-input
      height: 0
      padding: 0
      border-width: 0
      outline: none
      font-size: 0
      background: #F8F8F8
      transition: height .3s ease
      color: #181818
      &.active, &.success, &.error
        height: 2.4rem
        font-size: 1.6rem
      &.error
        background: #FFF2F2

    &-prompt
      font-size: 1.6rem
      color: #5C5C5C
      transition: all .3s ease
      &.active, &.success, &.error
        margin-bottom: .4rem
        font-size: 1.2rem
        font-weight: 700
        line-height: 1.6rem
      &.active
        color: #5C5C5C
      &.success
        color: #28B411

</style>
